export default class Richcontent {
  protected html: string | undefined;

  protected type: string | undefined;

  getHtml(): string | undefined {
    return this.html;
  }

  getType(): string | undefined {
    return this.type;
  }

  setHtml(value: string): void {
    this.html = value;
  }

  setType(value: string): void {
    this.type = value;
  }

  toXml(document: Document): HTMLElement {
    const richcontentElem = document.createElement('richcontent');
    if (this.type) {
      richcontentElem.setAttribute('TYPE', this.type);
    }
    
    if (this.html) {
      // Create proper HTML structure manually instead of using DocumentFragment
      const htmlElem = document.createElement('html');
      const headElem = document.createElement('head');
      const bodyElem = document.createElement('body');

      // Parse the HTML content to extract paragraphs
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.html;
      const paragraphs = tempDiv.getElementsByTagName('p');

      // Add each paragraph to the body
      Array.from(paragraphs).forEach(p => {
        const newP = document.createElement('p');
        newP.textContent = p.textContent || '';
        bodyElem.appendChild(newP);
      });

      htmlElem.appendChild(headElem);
      htmlElem.appendChild(bodyElem);
      richcontentElem.appendChild(htmlElem);
    }

    return richcontentElem;
  }
}
